import { ChangeEvent } from 'react'

import { Input } from '@dc-shared-web/components/shadcn'
import { AIConfigModalValues } from '@dc-shared-web/components/features/AIConfigDialog/types'

const DisplayLabelRow = ({
  values,
  disabled,
  onChange,
}: {
  values: AIConfigModalValues
  disabled?: boolean
  onChange: (values: AIConfigModalValues) => void
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange({ ...values, displayLabel: e.target.value })
  }

  // DisplayLabel is provided for some re-used prompts, but
  // not provided for ephemeral prompts like chats from the
  // doc-review UI
  if (!('displayLabel' in values)) return null

  return (
    <div className='tw-flex tw-flex-col tw-gap-1'>
      <p className='tw-text-sm'>Display Label</p>
      <Input
        type='text'
        value={values.displayLabel || ''}
        onChange={handleChange}
        disabled={disabled}
        placeholder='Enter user-visible label for the response'
      />
    </div>
  )
}

export default DisplayLabelRow
